import { render, staticRenderFns } from "./AUserDetailStaff.vue?vue&type=template&id=ffd8f71a&scoped=true"
import script from "./AUserDetailStaff.vue?vue&type=script&lang=js"
export * from "./AUserDetailStaff.vue?vue&type=script&lang=js"
import style0 from "./AUserDetailStaff.vue?vue&type=style&index=0&id=ffd8f71a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd8f71a",
  null
  
)

export default component.exports